import React, { Component } from 'react';

class Contact extends Component {
    render() {

        return (
            <article>
                <ul>
                    <li>Gmail szluis0</li>
                    <li>GitHub _szluis</li>
                    <li>Twitter _szluis</li>
                    <li>Instagram _szluis</li>
                </ul>
            </article>
        )
    }
}

export default Contact;